import React, { useState } from "react";
import { observer } from "mobx-react";
import { makeApi, URLS } from "Utils/apiURL";

// Small popup shown when starting a new seller profile from the settings list.
// Prompts only for the company website. On auto-fill success (or "fill manually"),
// invokes onProceed with the seed profile data so the parent can navigate to the
// full-page editor.
const SellerUrlPromptPopup = observer(({ onProceed, onClose }) => {
  const [website, setWebsite] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const enrich = () => {
    if (!website.trim()) return;
    setLoading(true);
    setError("");
    makeApi({
      url: URLS.deepResearchEnrichSeller,
      method: "POST",
      data: { website: website.trim() }
    })
      .then((res) => {
        setLoading(false);
        if (res?.data && !res.data.error) {
          onProceed({ ...res.data, website: website.trim() });
        } else {
          // Bad response — let user fill manually but warn.
          setError("Could not fetch data. Continue and fill manually?");
        }
      })
      .catch(() => {
        setLoading(false);
        setError("Failed to connect. Continue and fill manually?");
      });
  };

  const proceedManual = () => {
    onProceed({ website: website.trim() });
  };

  return (
    <div className="drPopupOverlay" onClick={onClose}>
      <div className="drPopup" onClick={(e) => e.stopPropagation()}>
        <div className="drPopupHeader">
          <h3>Set Up Seller Profile</h3>
          <span className="drPopupClose" onClick={onClose}>
            ✕
          </span>
        </div>
        <div className="drPopupBody">
          <p className="drPopupIntro">
            Enter your company website and we'll auto-fill the profile so you can
            review and edit it on the next page.
          </p>
          <div className="drInputGroup">
            <label>Company Website</label>
            <input
              type="text"
              placeholder="e.g. salesgear.io"
              value={website}
              onChange={(e) => setWebsite(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && enrich()}
              autoFocus
            />
          </div>
          {error && <p className="drPopupError">{error}</p>}
        </div>
        <div className="drPopupFooter">
          <button className="drPopupBtn secondary" onClick={proceedManual}>
            Fill Manually
          </button>
          <button
            className="drPopupBtn primary"
            onClick={enrich}
            disabled={loading || !website.trim()}
          >
            {loading ? "Analyzing..." : "Auto-Fill →"}
          </button>
        </div>
      </div>
    </div>
  );
});

export default SellerUrlPromptPopup;
